import { jwtDecode } from "jwt-decode";

export function formatDate(dateString,withTime=true) {
	try{
		const date = new Date(dateString);
		return withTime ? new Intl.DateTimeFormat('en-GB', {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
			hour12: true
		}).format(date).replace(" at ",", ")
		:new Intl.DateTimeFormat('en-GB', {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
		}).format(date).replace(" at ",", ");
	}catch (e){
		return dateString
	}
}

export function checkExpiry(submittedDate, condition = "today") {
	if (submittedDate == null)
		return false;
	const now = new Date();
	const submitted = new Date(submittedDate);
	now.setSeconds(0)&& now.setHours(0)&& now.setMinutes(0);
	submitted.setSeconds(0)&& submitted.setHours(0)&& submitted.setMinutes(0);


	switch (condition.toLowerCase()) {
		case "today":
			return now > submitted;
			// console.log("at",submitted, now,now.getMilliseconds() , submitted.getMilliseconds());
			// return now.getMilliseconds() == submitted.getMilliseconds();
		//   checkDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		break;
		case "last week":
			return new Date(now.getFullYear(),now.getMonth(),now.getDate()-7) >= submitted > now;
		case "this week":
			return now <= submitted <= new Date(now.getFullYear(),now.getMonth(),now.getDay()+7);
		//   checkDate = new Date(now.getFullYear(),now.getMonth(),now.getDay()+7)
		break;
		case "this month":
			return now <= submitted <= new Date(now.getFullYear(),now.getMonth()+1,0)
		//   checkDate = new Date(now.getFullYear(), now.getMonth(), 1);
		break;
		case "last month":
			return new Date(now.getFullYear(),now.getMonth()-1,1) <= submitted <= new Date(now.getFullYear(),now.getMonth(),0);
		//   checkDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
		break;
		case "next month":
			return new Date(now.getFullYear(),now.getMonth()+1,1) <= submitted <= new Date(now.getFullYear(),now.getMonth()+2,0);;
		//   checkDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
		break;
		default:
		throw Error("Accepted options are: 'today', 'this week', 'this month', 'last month', 'next month'");
	}
}

export function getAuthToken(){
	const token = localStorage.getItem("token");
	if(token == null){
		return "none";
	}
	const decoded = jwtDecode(token );
	return decoded;

}


export function getUserPermission(){
	return getAuthToken().permissions;
}

export function getUserId(){
	return getAuthToken().user_id;
}

export function formatCurrency(value, showCurrency = false) {
	if (typeof value !== "number") {
		value = Number(value);
		if (isNaN(value)) return value;
	}
	if (showCurrency) {
		return value.toLocaleString('en-US', { style: 'currency', currency: 'GHS', minimumFractionDigits: 0, maximumFractionDigits: 2 });
	} else {
		return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
	}
}

export function capitalize(value){
    return value.charAt(0).toUpperCase() + value.slice(1);
}